import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"rank-change",
	() => import("../ui/rank-popup"),
)
